import { TApplication } from 'lendingApi/applications.types';
import styles from './ApplicantCell.module.css';

type TProps = {
  customer: TApplication['customer'];
};

export const ApplicantCell = ({ customer }: TProps) => {
  return (
    <div className={styles.applicant} data-testid="applicant-cell">
      {[customer?.first_name, customer?.last_name].filter(Boolean).join(' ')}
    </div>
  );
};
